import { theme } from '../../../../themes/main';
import { SxStyles } from '../../../../types';

export const styles: SxStyles = {
  inputRoot: {
    '.MuiAutocomplete-inputRoot.MuiOutlinedInput-root': {
      pl: '14px',
      '& input': {
        pl: theme.spacing(5),
      },
    },
  },
  selectFieldItem: {
    p: { lg: 6 },
  },
  selectFieldItemBox: {
    p: theme.spacing(4),
  },
};
